module.exports = __webpack_public_path__ + "static/media/earning.e4840abe.svg";